import { useMediaQuery } from '@mui/material'
import { PureLightTheme } from '../styles/theme'
import { useIsPwa } from './useIsPwa'

export function usePwaMobile(): boolean {
  const isMobile = useMediaQuery(PureLightTheme.breakpoints.down('md'))
  const isPwa = useIsPwa()
  return isPwa && isMobile
}
